import JwtDecode from 'jwt-decode';

import { type CognitoNavinaJwt, useAuthStore } from '../stores/authStore';

import type { emrNames } from '../types';

export function useEmrName(): emrNames {
	const authStore = useAuthStore();

	let emrName;

	if (authStore && authStore.getToken) {
		const tokenInfo = JwtDecode<CognitoNavinaJwt>(authStore.getToken);
		if (tokenInfo.emrName) {
			emrName = tokenInfo.emrName;

			if (emrName) {
				// eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- Legacy code
				emrName = emrName.toLowerCase() as emrNames;
			}
		}
	}

	// @ts-expect-error - Legacy code
	return emrName;
}
